import React, { FC } from 'react'
import { useFormik } from 'formik'
import { createStyles, makeStyles } from '@material-ui/core'

import { DispatchStateCreateDto } from './entities/DispatchStateCreateDto'
import { Modal } from '../../components/_EOS/Modal'
import { DispatchStateForm } from './forms/DispatchStateForm'
import { useApi } from '../../hooks/useApi'
import { create } from './api'
import { Status } from '../../hooks/useFetchState'
import { dispatchStateSchema } from './forms/schema'

interface Props {
    open: boolean
    onClose: (success?: boolean) => void
}

export const DispatchStateCreate: FC<Props> = ({
    open,
    onClose,
}) => {
    const { state, callApi } = useApi()
    const styles = useStyles()

    const {
        values,
        errors,
        handleChange,
        resetForm,
        submitForm
    } = useFormik({
        initialValues: {
            stateName: '',
            dispatchStateTypeId: 1,
            active: true
        },
        onSubmit: values => {
            sendData(values)
        },
        validateOnChange: true,
        validationSchema: dispatchStateSchema
    })

    const sendData = (dispatchState: DispatchStateCreateDto) => {
        callApi(create(dispatchState))
            .then(() => {
                resetForm()
                onClose(true)
            })
    }

    const handleSuccessButton = () => {
        submitForm()
    }

    const handleClose = () => {
        resetForm()
        onClose()
    }

    return (
        <Modal
            open={open}
            title='Crear Estado Homologado'
            loading={state.status === Status.Loading}
            error={state.status === Status.Error ? state.error : undefined}
            cancelButton={{
                title: 'Cancelar',
                action: handleClose
            }}
            successButton={{
                title: 'Guardar',
                action: handleSuccessButton
            }}>

            <div className={styles.container}>
                <DispatchStateForm values={values} errors={errors} handleChange={handleChange}/>
            </div>

        </Modal>
    )
}

const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        input: {
            marginBottom: 20,
        }
    })
)
